import React from 'react';
import {observer} from 'mobx-react';
import {LauncherComponentBase} from '../../base-components/launcher-component-base';
import TextField from '@material-ui/core/TextField';
import {GameCustomSettings} from '../../../services/orbit-configs-storage/configs-storage.service.interface';
import Grid from '@material-ui/core/Grid/Grid';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip'
import {Check} from '@sparkware/app-utils';
import {Image} from '../../../../app-react/components/raw-components/image/image';

export interface SelectedGameFromSdmComponentProps {
    gameType: number;
}

@observer
export class SelectedGameFromSdmComponent extends LauncherComponentBase<SelectedGameFromSdmComponentProps> {

    private _getCustomGameSettings(): GameCustomSettings {
        return this.services.gamesCustomization.getGameCustomSettings(this.props.gameType) || {}
    }

    private _updateCustomUrl = (value) => {
        this.services.gamesCustomization.setGameCustomSettings(this.props.gameType, {...this._getCustomGameSettings(), customUrl: value});
    };

    private _deleteGame = () => {
        this.services.gamesCustomization.removeSdmGame(this.props.gameType);
    };

    render() {
        let gamesInfo = this.services.sdm.gamesInfo;
        let gameInfo = gamesInfo[this.props.gameType];
        if(!gameInfo) {
            if(!Check.isEmpty(gamesInfo)) { // we print the error message only if the SDM games map contains other games but not this one.
                this.services.logger.error(`Game type ${this.props.gameType} doesn't exists in the SDM games list`);
            }
            return null;
        }

        let customGameSettings = this._getCustomGameSettings();
        const fallbackImage = '/launcher-assets/game_icon_placeholder.png';

        return (
            <Grid container spacing={0} alignItems='center' justify="center">
                <Grid item xs>
                    <Image src={gameInfo.icon ? gameInfo.icon : fallbackImage} fallbackSrc={fallbackImage}></Image>
                </Grid>
                <Grid item xs={9}>
                    <h2>{gameInfo.gameType} - {gameInfo.title}</h2>
                    <h4>{gameInfo.combineVendorAndCompanyName()}</h4>
                    <div>
                        <TextField fullWidth
                                   label={`Custom URL`}
                                   value={customGameSettings.customUrl || ''}
                                   onChange={(event) => this._updateCustomUrl(event.target.value)}
                        InputProps={{
                            disableUnderline: true
                        }}/>
                    </div>
                </Grid>
                <Grid item xs>
                    <Tooltip title='Remove this game'>
                        <IconButton color="secondary" size={(this.services.deviceTypeDetection.isMobile ? "small" : "medium")} onClick={this._deleteGame}>
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                    </Tooltip>


                </Grid>

            </Grid>
        )
    }
}

